// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"ber_a bik_ea bik_ke bik_ju bik_sn bik_wl"};